import React from 'react';

import { BrowserRouter as Router, Route, Switch, Redirect,Routes } from 'react-router-dom';


import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Home from './pages/Home/Home';
import Services from './pages/Service/Services';
import Testimonial from './pages/Testimonial/Testimonial';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import TopHeader from './Components/TopHeader/TopHeader';
import WhatsAppButton1 from './Components/WhatsAppButton/WhatsAppButton';
import FaceBook from './Components/FaceBook/FaceBook';
import Instagram from './Components/Instagram/Instagram';
import ScrollToTopButton from './Components/ScrollToTopButton/ScrollToTopButton'
import OilFilter from './pages/OilFilter/OilFilter';
import DeselFilter from './pages/DeselFilter/DeselFilter';
import FuelStrainer from './pages/FuelStrainer/FuelStrainer';
import InlinepaperOilfilters from './pages/InlinepaperOilfilters/InlinepaperOilfilters'
import HydraulicFilterSystem from './pages/HydraulicFilterSysytem/HydraulicFilterSystem'
import ThankYou from './Components/Thankyou/ThankYou';
const App = () => {
 
  return (
   <Router>
    <TopHeader/>
    <Navbar/>
    <Routes>
        <Route path="/" element={<Home/>}/> 
        <Route path="/About" element={<About/>}/> 
        <Route path="/Contact" element={<Contact/>}/> 
        <Route path="/Services" element={<Services/>}/> 
        <Route path="/Testimonial" element={<Testimonial/>}/> 
        <Route path="/OilFilter"    element={<OilFilter/>}/>
        <Route path="/DeselFilter"   element={<DeselFilter/>}/>
        <Route path="/FuelStrainer"   element={<FuelStrainer/>}/>
        <Route path="/InlinepaperOilfilters" element={<InlinepaperOilfilters/>}/>
        <Route path="/HydraulicFilterSystem" element={<HydraulicFilterSystem/>}/>
        <Route path="/ThankYou" element={<ThankYou/>}/>
    </Routes>  
    <ScrollToTopButton/>
    <WhatsAppButton1/> 
   
    <FaceBook/>
    <Instagram/>
    <Footer/>
   </Router>
  );
}

export default App;
